const PORTFOLIO_METRICS = [
    {
        title: 'Cash Balance',
        subtitle: '',
        items: [
            {
                title: 'Cash Balance',
                value: '$0.00',
                className: 'dotted-border'
            },
            {
                title: 'Restricted Cash',
                value: '$0.00'
            },
            {
                title: 'Cash',
                value: '$0.00'
            }
        ]
    },
    {
        title: 'Portfolio Value',
        subtitle: '',
        items: [
            {
                title: 'Portfolio Value',
                value: '$0.00'
            },
            {
                title: `Day's Gain Unrealized`,
                value: '$0.00 (0%)',
                style: {
                    color: '#008E2F'
                }
            },
            {
                title: `Units Value`,
                value: '$0.00 (0%)',
                style: {
                    color: '#008E2F'
                }
            },
            {
                title: `My Units Value`,
                value: '$0.00 (0%)',
                style: {
                    color: '#008E2F'
                }
            }
        ]
    },
    {
        title: 'My Units',
        items: [
            {
                title: 'My units value',
                value: '$0'
            },
            {
                title: '# Units for Trade',
                value: '$0'
            },
            {
                title: 'Daily Gain',
                value: '$0'
            }
        ],
    },
];
export const PORTFOLIO_PENDINGS = [
    {
        Symbol: "THE_BOX",
        description: "desc edit",
        OrderType: "Auction",
        bid_per_unit: "40.00",
        total_units: 20,
        unit_price: "12.00",
        minimum_units: 2
    }
]
export default PORTFOLIO_METRICS;